import axios from 'axios';

// Smart API URL detection
// In production (sidekick.bio2vec.net), use relative URLs so nginx can route
// In local development (localhost), use absolute URL to backend port
const getApiUrl = () => {
  const hostname = window.location.hostname;
  
  // If on production domain, use relative URLs (nginx will handle routing)
  if (hostname === 'sidekick.bio2vec.net') {
    return '';
  }
  
  // Local development - use explicit backend port
  return 'http://localhost:8008';
};

const API_URL = getApiUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiService = {
  // Health check
  healthCheck: () => api.get('/api/health'),

  // Statistics
  getStats: () => api.get('/api/stats'),

  // Search
  searchByIngredient: (name, limit = 100) => 
    api.get(`/api/search/ingredient/${encodeURIComponent(name)}`, { params: { limit } }),

  searchByRxCUI: (rxcui) => 
    api.get(`/api/search/rxcui/${rxcui}`),

  searchByProduct: (name, limit = 100) => 
    api.get(`/api/search/product/${encodeURIComponent(name)}`, { params: { limit } }),

  autocompleteIngredient: (query, limit = 20) => 
    api.get(`/api/autocomplete/ingredient/${encodeURIComponent(query)}`, { params: { limit } }),

  // Drug details
  getDrugDetails: (collectionId) => 
    api.get(`/api/drug/${collectionId}`),

  getDrugProducts: (collectionId) => 
    api.get(`/api/drug/${collectionId}/products`),

  getSideEffects: (collectionId) => 
    api.get(`/api/drug/${collectionId}/side-effects`),

  getDiseaseIndications: (collectionId) => 
    api.get(`/api/drug/${collectionId}/disease-indications`),

  getPhenotypeIndications: (collectionId) => 
    api.get(`/api/drug/${collectionId}/phenotype-indications`),

  getDrugIndications: (collectionId) => 
    api.get(`/api/drug/${collectionId}/drug-indications`),

  getDiseaseContraindications: (collectionId) => 
    api.get(`/api/drug/${collectionId}/disease-contraindications`),

  getPhenotypeContraindications: (collectionId) => 
    api.get(`/api/drug/${collectionId}/phenotype-contraindications`),

  getDrugContraindications: (collectionId) => 
    api.get(`/api/drug/${collectionId}/drug-contraindications`),

  getEvidence: (collectionId) => 
    api.get(`/api/drug/${collectionId}/evidence`),

  // SPARQL
  executeSparql: (query) => 
    api.post('/api/sparql', { query }),
};

export default apiService;
